export default "__VITE_ASSET__CMfNRODn__"